import { FC } from "react";
import { CommonTable, ContentCell, LabelCell, NormalRow } from "../components/CommonTable";
import SummarySection from "../../../components/forms/SummarySection";
import { formatToDisplayQuoteReadableDate } from "../../../utils/date";
import CommonRow from "../../components/CommonRow";
import { proposerEventDetailsState } from "../bind/types";
import formatToAddressLines from "../../../helpers/travel/address";

type Props = {
  state: proposerEventDetailsState;
  editProposalDetailsLink: string;
  t: any;
};
const getCoverageDate = (date: Date | null) => {
  return date && formatToDisplayQuoteReadableDate(new Date(date));
};
const hasDistrictTerritory = (value?: string) => (value ? `, ${value}` : "");
const SummarySections: FC<Props> = ({ state, t, editProposalDetailsLink }) => {
  const address = {
    postalCode: state.postalCode,
    number: state.houseNumber,
    streetName: state.streetName,
    floorNumber: state.floorNumber,
    unitNumber: state.unitNumber,
    buildingName: state.buildingName,
  };
  const eventAddress = {
    postalCode: state.eventPostalCode,
    number: state.eventHouseNumber,
    streetName: state.eventStreetName,
    floorNumber: state.eventfloorNumber,
    unitNumber: state.eventunitNumber,
    buildingName: state.eventBuildingName,
  };

  const addressState = hasDistrictTerritory(state?.district);
  const addressTerritory = hasDistrictTerritory(state?.territory);
  const eventDistrict = hasDistrictTerritory(state?.eventDistrict);
  const eventTerritory = hasDistrictTerritory(state?.eventTerritory);

  const formattedAddress = formatToAddressLines(address);
  const formattedEventAddress = formatToAddressLines(eventAddress);
  return (
    <>
      <SummarySection name={t("SummaryLabels.proposerDetails")} link={editProposalDetailsLink}>
        <CommonTable className="w-full mt-2 table-fixed">
          <NormalRow>
            <ContentCell>{t("SummaryLabels.companyName")}</ContentCell>
            <LabelCell>{state.proposerName}</LabelCell>
          </NormalRow>
          <NormalRow>
            <ContentCell>{t("SummaryLabels.uenNo")}</ContentCell>
            <LabelCell>{state.uenNumber}</LabelCell>
          </NormalRow>
          <NormalRow>
            <ContentCell>{t("SummaryLabels.mobileNo")}</ContentCell>
            <LabelCell>{state.mobileNumber}</LabelCell>
          </NormalRow>
          <NormalRow>
            <ContentCell>{t("SummaryLabels.email")}</ContentCell>
            <LabelCell>{state.email}</LabelCell>
          </NormalRow>
          <NormalRow>
            <ContentCell>{t("SummaryLabels.correspondenceAddress")}</ContentCell>
            <LabelCell>
              <p>{formattedAddress[0]}</p>
              <p>
                {" "}
                {formattedAddress[1]} {addressState} {addressTerritory}{" "}
              </p>
              <p>{formattedAddress[2]}</p>
            </LabelCell>
          </NormalRow>
          <NormalRow>
            <ContentCell>{t("SummaryLabels.eventName")}</ContentCell>
            <LabelCell>{state.eventTitle}</LabelCell>
          </NormalRow>
          <NormalRow>
            <ContentCell>{t("SummaryLabels.eventAddress")}</ContentCell>
            <LabelCell>
              <p>{formattedEventAddress[0]}</p>
              <p>
                {" "}
                {formattedEventAddress[1]} {eventDistrict} {eventTerritory}{" "}
              </p>
              <p>{formattedEventAddress[2]}</p>
            </LabelCell>
          </NormalRow>
        </CommonTable>
      </SummarySection>
      <SummarySection name={t("SummaryLabels.coverage")} link={editProposalDetailsLink}>
        <CommonTable className="w-full mt-2 table-fixed">
          <NormalRow>
            <ContentCell>{t("SummaryLabels.limitperOccurrence")}</ContentCell>
            <LabelCell>
              {t("SummaryLabels.currency")} {state.limit}
            </LabelCell>
          </NormalRow>
          <NormalRow>
            <ContentCell>{t("SummaryLabels.periodofCoverage")}</ContentCell>
            <LabelCell>
              {getCoverageDate(state.coverageStartDate)} - {getCoverageDate(state.coverageEndDate)} {t("SummaryLabels.bothDaysInclusive")}
            </LabelCell>
          </NormalRow>
          {state.additionalInsured === "yes" ? (
            <>
              <CommonRow label={t("SummaryLabels.additionalInsuredLandlord")} value={state.landlord} />
              <CommonRow label={t("SummaryLabels.additionalInsuredPrincipal")} value={state.principal} />
            </>
          ) : (
            <NormalRow>
              <ContentCell>{t("SummaryLabels.additionalInsured")}</ContentCell>
              <LabelCell>{"-"}</LabelCell>
            </NormalRow>
          )}
        </CommonTable>
      </SummarySection>
    </>
  );
};

export default SummarySections;
